import VerticalContentCard from './VerticalContentCard';
export default VerticalContentCard;
